import React, { Fragment } from 'react'
import FriendLabel from './FriendLabel'
import { InputError } from '@foodsby/nutrient'
import { SimpleSpinner } from '../common/SimpleSpinner'

export const NoPendingRequests = () => (
  <Fragment>
    <div className="row center-xs">
      <div className="noFriendRequests">
        You currently have no pending friend requests!
      </div>
    </div>
    <div className="row center-xs">
      <p className="col-xs-12 start-xs noRequests">
        Invite a friend/co-worker to become your friend in the panel to the
        right. You will be able to see your friend's favorite food and where
        they have ordered from for the day!
      </p>
    </div>
  </Fragment>
)

const PendingRequests = ({
  incomingFriendRequests,
  outgoingFriendRequests,
  isLoadingFriendRequests,
  cancelOutgoingFriendRequest,
  friendRequestLoadingError,
  friendRequestResponseError,
  cancelOutgoingRequestError,
  friendRequestResponse,
  isRespondingToFriendRequest,
  isCancelingOutgoingRequest,
  isLoadingFriends
}) => {
  return (
    <div>
      {isLoadingFriendRequests ||
      isRespondingToFriendRequest ||
      isLoadingFriends ||
      isCancelingOutgoingRequest ? (
        <SimpleSpinner spinnerClass={{ spinnerSpace: true }} />
      ) : (
        <ul className="requestList">
          {incomingFriendRequests &&
            incomingFriendRequests.length === 0 &&
            outgoingFriendRequests &&
            outgoingFriendRequests.length === 0 && <NoPendingRequests />}
          {incomingFriendRequests &&
            incomingFriendRequests.length >= 1 && [
              <h3 key="incoming" className="requestHeader">
                Recieved
              </h3>,
              incomingFriendRequests.map(request => (
                <li className="requestListItem" key={request.connectionId}>
                  <div className="col-xs-12">
                    <div className="col-xs-9 start-xs">
                      <FriendLabel
                        firstName={request.firstName || ''}
                        lastName={request.lastName || ''}
                        showName={
                          request.firstName !== '' && request.lastName !== ''
                        }
                        email={request.email}
                        size="large"
                      />
                    </div>
                    <div className="col-xs-3 end-xs">
                      <button
                        className="link"
                        onClick={() =>
                          friendRequestResponse({
                            action: 'ACCEPT',
                            requestId: request.connectionId
                          })
                        }
                      >
                        Accept
                      </button>
                      <span className="friendLink secondary">|</span>
                      <button
                        className="link"
                        onClick={() =>
                          friendRequestResponse({
                            action: 'DECLINE',
                            requestId: request.connectionId
                          })
                        }
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                </li>
              ))
            ]}
          {outgoingFriendRequests &&
            outgoingFriendRequests.length >= 1 && [
              <h3 key="outgoing" className="requestHeader">
                Sent
              </h3>,
              outgoingFriendRequests.map(request => (
                <li className="requestListItem" key={request.connectionId}>
                  <div className="col-xs-12">
                    <div className="col-xs-10 start-xs">
                      <FriendLabel
                        firstName={request.firstName || ''}
                        lastName={request.lastName || ''}
                        showName={
                          request.firstName !== '' && request.lastName !== ''
                        }
                        email={request.email}
                        size="large"
                      />
                    </div>
                    <div className="col-xs-2 end-xs">
                      <button
                        className="link"
                        onClick={() =>
                          cancelOutgoingFriendRequest(request.connectionId)
                        }
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </li>
              ))
            ]}
        </ul>
      )}
      {(friendRequestLoadingError || cancelOutgoingRequestError) && (
        <InputError
          isOpened={
            (friendRequestLoadingError && friendRequestLoadingError !== null) ||
            (cancelOutgoingRequestError && cancelOutgoingRequestError !== null)
          }
        >
          {friendRequestLoadingError || cancelOutgoingRequestError}
        </InputError>
      )}
    </div>
  )
}

export default PendingRequests
